import { Component, EventListener, GondelBaseComponent } from '@gondel/core';

/**
 * downloader-clipboard module implementation.
 * @author Nikola Antic <nikola.antic@emea.merkleinc.com>
 */

enum Selectors {
	ClipboardButton = '.js-clipboard-button .a-button',
	ClipboardButtonWrap = '.js-clipboard-button',
}

/**
 * All custom attributes inside the current _ctx object
 */
enum CustomAttributes {
	ClipboardText = 'data-clipboard-text',
}

@Component('DownloaderClipboard')
export class DownloaderClipboard extends GondelBaseComponent {
	private _clipboardText!: string;

	public start() {
		const clipboardButtonWrap = this._ctx.querySelector(Selectors.ClipboardButtonWrap) as HTMLDivElement;
		this._clipboardText = clipboardButtonWrap?.getAttribute(CustomAttributes.ClipboardText) ?? '';
	}

	@EventListener('click', Selectors.ClipboardButton)
	public _onClipboardButtonClick(event: Event): void {
		event.preventDefault();
		if (this._clipboardText) {
			navigator.clipboard.writeText(this._clipboardText);
		}
	}
}
